import type { AddEmergencyConfigRequest } from '@/../generated-client/models';
import { useEmergencyConfigFields, type EmergencyConfigFieldValues } from './useEmergencyConfigFields';

export function useEmergencyConfigCreate(initialConfig: AddEmergencyConfigRequest) {
  const initialValues: EmergencyConfigFieldValues = {
    specName: initialConfig.spec_name,
    impactDetection: initialConfig.impact_detection,
    fallDetection: initialConfig.fall_detection,
    arcFlashDetection: initialConfig.arc_flash_detection,
  };

  const fields = useEmergencyConfigFields(initialValues);

  const submitConfig = (): AddEmergencyConfigRequest => ({
    org_code: initialConfig.org_code,
    spec_name: fields.specName,
    impact_detection: fields.impactDetection,
    fall_detection: fields.fallDetection,
    arc_flash_detection: fields.arcFlashDetection,
    should_force_apply_this_update: false,
  });

  return { ...fields, submitConfig };
}
